export { default } from "@src/features/agent/components/AgentScreenContent";
